import { useConnectorsUI } from "@mirage/mosaics/SettingsPage/useConnectorsUI";
import useConnectors from "@mirage/service-connectors/useConnectors";
import { useDismissableModule } from "@mirage/service-onboarding/useDismissableModule";
import { useDashUserAttributes } from "@mirage/shared/eligibility/hooks/useDashUserAttributes";
import { isDashStandaloneWeb } from "@mirage/shared/utils/environment-detection";
import { useCallback } from "react";

const DISMISSED_ADD_APPS_UPSELL_IN_CHAT_SOURCE_MODAL =
  "dismissedAddAppsUpsellInChatSourceModal";
const CONNECTION_COUNT_THRESHOLD = 3;

export const useAddAppsUpsellInChatSourceModal = () => {
  const { dismissed, setDismissed } = useDismissableModule(
    DISMISSED_ADD_APPS_UPSELL_IN_CHAT_SOURCE_MODAL,
  );
  const { connections, hasFinishedInitialFetch } = useConnectors();
  const numConnections = connections.length;

  const { openConnectors } = useConnectorsUI();
  const { userAttributes } = useDashUserAttributes();
  const isWebBridgeUser = isDashStandaloneWeb() && userAttributes?.hasDashInFss;
  const showAddAppsUpsell =
    !!isWebBridgeUser &&
    !dismissed &&
    hasFinishedInitialFetch &&
    numConnections < CONNECTION_COUNT_THRESHOLD;

  const onDismiss = useCallback(() => {
    setDismissed(true);
    // TODO: add logging here
  }, [setDismissed]);

  const onOpenAddApps = useCallback(() => {
    // TODO: add logging here
    openConnectors();
  }, [openConnectors]);

  return {
    showAddAppsUpsell,
    onDismiss: showAddAppsUpsell ? onDismiss : () => {},
    onOpenAddApps: showAddAppsUpsell ? onOpenAddApps : () => {},
  };
};
